import React from "react";
import MedicalHeader from "../components/header/MedicalHeader";
import MedicalSidebar from "../components/sidebar/MedicalSidebar";

const MedicalLayout = ({ children, noSidebar }) => {
    return (
        <div className="flex flex-col h-screen bg-[#F4FAF1]">
            {!noSidebar && <MedicalHeader />}
            <div className="flex flex-1 h-screen overflow-hidden">
                {!noSidebar && <MedicalSidebar />}
                <main className={"flex-1 overflow-y-auto" + `${noSidebar ? "" : " p-4 sm:ml-1"}`}>{children}</main>
            </div>
        </div >
    );
};

export default MedicalLayout;
